import { Header } from './Header';
import { Footer } from './Footer';
import { Toaster } from 'sonner';
import SiteMetadata from './SiteMetadata';
import AnalyticsTracker from '../common/AnalyticsTracker';
import CookieConsentBanner from '../common/CookieConsentBanner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteMetadata />
      <AnalyticsTracker />
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <CookieConsentBanner />
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default Layout;
